import PropTypes from 'prop-types'
import React from 'react'
import SydSwitch from '../../../../../commonDesign/SydSwitch'

function SettingToggleRow ({ title, description, enabled, onChange, disabled, style }) {
  return (
    <div className='flex items-center justify-between gap-2 p-3' style={style}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className='flex items-center gap-2 flex-wrap'>
          <div className='font-size-sm font-medium'>{title}</div>
        </div>
        <div className='font-size-xs text-neutral-500 mt-1'>{description}</div>
      </div>
      <SydSwitch
        value={enabled}
        onChange={(_e, checked) => onChange(checked)}
        disabled={disabled}
        size='sm'
      />
    </div>
  )
}

SettingToggleRow.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  style: PropTypes.object
}

export default SettingToggleRow
